export const ENGLISH_TRANSLATIONS = {
	// MAIN COMPONENTS
	navbar: {
		options: {
			load: {
				title: 'Loads',
				loads: 'Initial Loads',
				load: 'Upload Files',
				status: 'Load Status'
			}
		},
		menu: {
			account: 'Account',
			return: 'Return to menu',
			logOut: 'Log Out'
		}
	},
	landing: {
		instruction: 'Use this dashboard to be able to review the files that will be uploaded to the system.',
		continue: 'Continue'
	},
	
	// FILTERS
	filters: {
		organization: 'Organization',
		workspace: 'Workspace',
		module: 'Module',
		submodule: 'Submodule',
		cycle: 'Cycle',
		areas: 'Areas',
		region: 'Region',
		zone: 'Zone',
		depot: 'Depot',
		group: 'Group',
		route: 'Route'
	},

	// LOAD FILE
	loadFile: {
		load: 'Load File',
		reviewBtn: 'Upload',
		msg: {
			loading: 'Loading file...',
			success: 'File loaded successfully!',
			error: 'Error loading file, check the information and try again.'
		}
	},
	loadTypeOptions: {
		restructure: 'Restructure',
		coordinates: 'Coordinates',
		cycle: 'Initial',
		single: 'Single'
	},
	loadFileInput: {
		loadType: 'Load type',
		description: 'Description',
		text: 'Click or drag files to this area to upload',
		hint: 'Please make sure that the file you attach is of type csv.',
		error: 'Only csv files allowed.'
	},
	loadForm: {
		create: {
			title: 'Create Load',
			msg: {
				success: 'Load created successfully!',
				error: 'Error creating load, please try again.'
			}
		},
		edit: {
			title: 'Edit Load',
			msg: {
				success: 'Load edited successfully!',
				error: 'Error editing the load, please try again.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Delete Load',
				description: 'Are you sure you want to delete this load?',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				success: 'Load deleted successfully!',
				error: 'Error deleting the load, please try again.'
			}
		},
		placeholder: {
			organization: 'Select an organization.',
			workspace: 'Select a workspace.',
			module: 'Select a module.',
			cycle: 'Select a cycle.',
			type: 'Select a type.',
			load: 'Select a load.',
			name: 'Input a name.',
			description: 'Input a description.'
		},
		validationMsg: {
			organization: 'Please select an organization.',
			workspace: 'Please select a workspace.',
			module: 'Please select a module.',
			cycle: 'Please select a cycle.',
			type: 'Please select a type.',
			name: 'Please input a name.',
			description: 'Please input a description.'
		},
		cancel: 'Cancel'
	},

	// LOAD STATUS
	loadStatus: {
		statusTable: {
			loading: 'Loading...',
			date: 'Date',
			actionButtons: {
				details: 'View Details',
				confirm: 'Confirm',
				discard: 'Discard'
			}
		}
	},
	loadStatusDetails: {
		title: 'File Information',
		card: {
			source: 'Source',
		},
		download: {
			button: 'Download',
			validationBtn: 'Validation',
			error: 'Error downloading file, please try again.'
		},
		process: {
			button: 'Process',
			successSingle: 'Processing file...',
			successMultiple: 'Processing files...',
			errorSingle: 'Error processing file, please try again.',
			errorMultiple: 'Error processing files, please try again.',
		},
		check: {
			button: 'Check',
			alert: {
				msg: 'Validation process underway',
				desc: 'Currently, the system is validating this file. Please come back later to access the information that will be uploaded.'
			}
		},
		review: {
			title: 'Information Summary',
			noAction: {
				badge: 'N',
				desc: 'No Action'
			},
			creation: {
				desc: 'Creation'
			},
			update: {
				badge: 'U',
				desc: 'Update'
			}
		},
		confirm: {
			msg: {
				success: 'The file has been confirmed for uploading!',
				error: 'Error in confirming the file for uploading!'
			}
		},
		discard: {
			msg: {
				success: 'The file has been discarded for uploading!',
				error: 'Error in discarding the file for uploading!'
			}
		},
		routesSummary: {
			addedLoacations: 'Added Locations',
			removedLocations: 'Removed Locations'
		},
		validationTitle: 'Validation process in progress.',
		validationDescription: 'The system is validating the file according to the established structure and rules. This process may take a few minutes.',
		validationLoadingStepChecking: 'Checking file',
		validationLoadingStepValidating: 'Validating rules',
		validationLoadingStepPreparing: 'Preparing results',
		validationHistory: {
			title: 'Validation History',
			selectHistoryPlaceholder: 'Select a history.',
		},
		movements: {
			title: 'Location Movements Summary',
			location: 'Location',
			fromRoute: 'From Route',
			toRoute: 'To Route',
			new: 'New',
			route: 'Route',
			locationsGained: 'Gained',
			locationsLost: 'Lost',
			netChange: 'Net Change',
			newLocations: 'New Locations',
			updateLocations: 'Updated Locations',
			changedLocations: 'Moved Locations',
			totalMovements: 'Total Movements',
			searchByCode: 'Search by code',
			movementType: 'Movement type',
			routesSummary: 'Routes Summary',
			details: 'Details',
			detailedMovements: 'Detailed Movements',
			noMovements: 'No location movements in this file'
		},
		discards: {
			title: 'Discarded Establishments Summary',
			totalDiscards: 'Total Discards',
			reason: 'Discard Reason',
			details: 'Details',
			noDiscards: 'No discarded establishments in this file'
		}
	},
	
	// CYCLE INFO
	cycle: {
		title: 'Cycles',
		loading: 'Loading cycles...',
		type: 'Type',
		creationDate: 'Creation Date',
		selectStart: 'Start Date',
		selectEnd: ' End Date',
		start: 'Start of cycle:',
		end: ' End of cycle:',
		workingDays: 'Working days:',
		currentDays: 'Days elapsed:',
		remainingDays: 'Remaining days:',
		routeCycle: {
			msg: {
				error: 'Error loading route cycle, please try again.'
			}
		},
		create: {
			title: 'Create Cycle',
			loading: 'Creating cycle...',
			success: 'Cycle created successfully!',
			error: 'Error creating cycle, please try again.'
		},
		edit: {
			title: 'Edit Cycle',
			loading: 'Editing cycle...',
			success: 'Cycle edited successfully!',
			error: 'Error editing cycle, please try again.'
		},
		startAction: {
			popconfirm: {
				title: 'Start Cycle',
				question: 'Are you sure you want to start this cycle?',
				description: 'This action will start the cycle and all the routes will be available for the users.',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				loading: 'Starting cycle...',
				success: 'Cycle started successfully!',
				error: 'Error starting cycle, please try again.'
			}
		},
		extend: {
			title: 'Extend Cycle',
			loading: 'Extending cycle...',
			success: 'Cycle extended successfully!',
			error: 'Error extending cycle, please try again.'
		},
		endAction: {
			popconfirm: {
				title: 'End Cycle',
				question: 'Are you sure you want to end this cycle?',
				description: 'This action will end the cycle and all the routes will no longer be available for the users.',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				loading: 'Ending cycle...',
				success: 'Cycle ended successfully!',
				error: 'Error ending cycle, please try again.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Delete Cycle',
				description: 'Are you sure you want to delete this cycle?',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				loading: 'Deleting cycle...',
				success: 'Cycle deleted successfully!',
				error: 'Error deleting cycle, please try again.'
			}
		},
		placeholder: {
			reference: 'Select an option.',
		},
		customTime: {
			checkbox: 'Set start or end time',
			startTime: 'Start time',
			endTime: 'End time',
			timezoneNote: 'Dates and times are saved in the organization timezone: {{timezone}}.',
			timezoneFallback: '(not configured on the organization, the default one is used)',
			timezoneLoading: 'Getting the organization timezone…',
			format: 'Format',
			format12h: '12 h',
			format24h: '24 h'
		},
		validationMsg: {
			reference: 'Please select an option.',
			date: 'Please select a date.',
			startTime: 'Please enter the start time.',
			endTime: 'Please enter the end time.',
			endBeforeStart: 'The end time must be later than the start time.'
		}
	},

	// ORGANIZATION ROUTES
	orgRoutes: {
		loading: 'Loading routes...',
		title: 'Routes'
	},
	routesTable: {
		headers: {
			name: 'Name',
			code: 'Code',
			locations: '# Locations',
			status: 'Status',
			module: 'Module',
			user: 'User',
			action: 'Action'
		}
	},
	routeUpdates: {
		msg: {
			loading: 'Loading route...',
			success: 'Route loaded successfully!',
			error: 'Error loading route!'
		}
	},
	routesMove: {
		button: 'Move routes',
		moveError: 'The routes are not from the same group, check and try again.',
		moveGroup: 'There are no available groups to move these routes to. Please close this form.',
		steps: {
			first: {
				desc:'Select the destination group'
			},
			second: {
				content: {
					title: 'Are you sure you want to move these routes?',
					from: 'From group:',
					to: 'To group:'
				}
			}
		},
		update: {
			groupsError: 'No group information found, please try again.',
			loading: 'Moving routes...',
			success: 'Route(s) moved successfully!',
			error: 'Error moving routes'
		}
	},

	// LOCATIONS
	locations: {
		loading: 'Loading locations...',
		table: {
			search: {
				search: 'Search',
				reset: 'Reset'
			}
		},
		finishChanges: 'Save Changes',
		move: 'Move locations'
	},
	locationsUpdates: {
		msg: {
			loading: 'Updating location info...',
			success: 'Updated location info successfully!',
			error: 'Error updating location info!'
		}
	},
	locationsMove: {
		steps: {
			first: {
				desc:'Select the destination route',
			},
			second: {
				title: 'Done',
				content: {
					title: 'Are you sure you want to move these locations?',
					from: 'From:',
					to: 'To:',
					back: 'Back',
					confirm: 'Confirm'
				}
			},
			continue: 'Continue'
		},
		update: {
			routesError: 'No route information found, please try again.',
			loading: 'Updating locations of the route',
			success: 'updated successfully!',
			error: 'Error updating route'
		}
	},

	// ERRORS
	errors: {
		title: 'Errors',
		loading: 'Loading errors...'
	},
	errorForm: {
		inputs: {
			alias: 'Alias',
			value: 'Value'
		},
		create: {
			title: 'Create Error',
			msg: {
				success: 'Error created successfully!',
				error: 'Failed to create error, please try again.'
			}
		},
		edit: {
			title: 'Edit Error',
			msg: {
				success: 'Error edited successfully!',
				error: 'Failed to edit error, please try again.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Delete Error',
				description: 'Are you sure you want to delete this error?',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				success: 'Error deleted successfully!',
				error: 'Failed to delete error, please try again.'
			}
		},
		placeholder: {
			organization: 'Select an organization.',
			alias: 'Enter an alias.',
			name: 'Enter a name.',
			description: 'Enter a description.',
			value: 'Enter an error value.'
		},
		validationMsg: {
			organization: 'Please select an organization.',
			alias: 'Please enter an alias.',
			name: 'Please enter a name.',
			description: 'Please enter a description.',
			value: {
				required: 'Please enter a valid error value.',
				min: 'The value must be greater than 0.'
			}
		},
		cancel: 'Cancel'
	},

	// SCHEMAS
	schemas: {
		title: 'Schemas',
		loading: 'Loading schemas...'
	},
	schemasForm: {
		inputs: {
			scope: 'Scope',
			value: 'Value',
			fieldType: 'Field Type',
			code: 'Code',
			identifier: 'Identifier',
			primary: 'Primary',
			check: 'Check',
			optional: 'Optional'
		},
		booleanOptions: {
			true: 'True',
			false: 'False'
		},
		searchName: 'Search by name', 
		create: {
			title: 'Create Schema',
			msg: {
				success: 'Schema created successfully!',
				error: 'Failed to create schema, please try again.'
			}
		},
		edit: {
			title: 'Edit Schema',
			msg: {
				success: 'Schema edited successfully!',
				error: 'Failed to edit schema, please try again.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Delete Schema',
				description: 'Are you sure you want to delete this schema?',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				success: 'Schema deleted successfully!',
				error: 'Failed to delete schema, please try again.'
			}
		},
		placeholder: {
			scope: 'Select a scope.',
			value: 'Select a value.',
			fieldType: 'Select a field type.'
		},
		validationMsg: {
			scope: 'Please select a scope.',
			value: 'Please select a value.',
			fieldType: 'Please select a field type.',
			boolean: 'Please select an option.',
			namePattern: 'Do not use accented letters (Áéióú ÁÉÍÓÚ ñ Ñ ü Ü)',
		},
		cancel: 'Cancel'
	},

	// RULES
	rules: {
		title: 'Rules',
		loading: 'Loading rules...',
	},
	rulesForm: {
		inputs: {
			active: 'Active',
			index: 'Index',
			type: 'Condition Type',
			number: 'Number',
			values: 'Values',
			actionType: 'Action Type',
			compoundConditions: 'Compound Conditions',
			operator: 'Operator',
			condition: 'Condition'
		},
		searchName: 'Search by name', 
		create: {
			title: 'Create Rule',
			msg: {
				success: 'Rule created successfully!',
				error: 'Failed to create rule, please try again.'
			}
		},
		edit: {
			title: 'Edit Rule',
			msg: {
				success: 'Rule edited successfully!',
				notModified: 'No changes were made, please make some changes and try again.',
				error: 'Failed to edit rule, please try again.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Delete Rule',
				description: 'Are you sure you want to delete this rule?',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				success: 'Rule deleted successfully!',
				error: 'Failed to delete rule, please try again.'
			}
		},
		placeholder: {
			schema: 'Select a schema.',
			type: 'Select a condition type.',
			values: 'Enter the values for validation.',
			extraValues: 'Values must be separated by commas (e.g., value1, value2, value3).',
			action: 'Select an action type.',
			compoundConditions: 'Compound conditions are complex logical rules that combine multiple criteria.'
		},
		validationMsg: {
			index: 'Please enter the order in which validation will be done.',
			indexRange: 'The index must be higher.',
			schema: 'Please select a schema.',
			type: 'Please select a condition type.',
			number: 'Please enter a number.',
			action: 'Please select an action type!',
			values : 'Please enter values in the correct format.',
		},
		cancel: 'Cancel'
	},

	// CONFIGURATIONS
	config: {
		title: 'Configurations',
		loading: 'Loading configurations...'
	},
	configForm: {
		inputs: {
			bq_project: 'BQ Project',
			bq_table: 'BQ Table',
			bq_table_prefix: 'BQ Table Prefix'
		},
		create: {
			title: 'Create Configuration',
			msg: {
				success: 'Configuration created successfully!',
				error: 'Failed to create configuration, please try again.'
			}
		},
		edit: {
			title: 'Edit Configuration',
			msg: {
				success: 'Configuration edited successfully!',
				error: 'Failed to edit configuration, please try again.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Delete Configuration',
				description: 'Are you sure you want to delete this configuration?',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				success: 'Configuration deleted successfully!',
				error: 'Failed to delete configuration, please try again.'
			}
		},
		placeholder: {
			bq_project: 'Enter a BQ Project.',
			bq_table: 'Enter a BQ Table.',
			bq_table_prefix: 'Enter a BQ Table Prefix.'
		},
		validationMsg: {
			bq_project: 'Please enter a BQ Project.',
			bq_table: 'Please enter a BQ Table.',
			bq_table_prefix: 'Please enter a BQ Table Prefix.'
		},
		cancel: 'Cancel'
	},

	// SETTINGS
	settings: {
		title: 'Settings',
		loading: 'Loading settings...'
	},
	settingsForm: {
		inputs: {
			dailyFrequency: 'Daily Frequency',
			weeklyFrequency: 'Weekly Frequency'
		},
		create: {
			title: 'Create Setting',
			msg: {
				success: 'Setting created successfully!',
				error: 'Failed to create setting, please try again.'
			}
		},
		edit: {
			title: 'Edit Setting',
			msg: {
				success: 'Setting edited successfully!',
				error: 'Failed to edit setting, please try again.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Delete Setting',
				description: 'Are you sure you want to delete this setting?',
				confirm: 'Confirm',
				cancel: 'Cancel'
			},
			msg: {
				success: 'Setting deleted successfully!',
				error: 'Failed to delete setting, please try again.'
			}
		},
		cancel: 'Cancel'
	},

	// UTILS COMPONENTS
	buttons: {
		add: 'Add',
		reset: 'Reset',
		search: 'Search',
		close: 'Close'
	},
	pagination: {
		rows: '/ page',
		of: 'of'
	},
	copyableText: {
		copy: 'Copy',
		copied: 'Copied',
		copyId: 'Copy ID',
		copiedId: 'ID Copied'
	},
	statusUpdate: {
		modalTitle: 'Update Status',
		history: 'History',
		noHistory: 'No history found',
		options: 'Options',
		success: 'Status updated successfully!',
		error: 'Error updating status, please try again.'
	},

	//BUTTONS
	buttons: {
		reset: 'Reset',
		search: 'Search',
		close: 'Close'
	},

	// STATUS DESCRIPTIONS
	statusDesc: {
		cycle: {
			none: 'None',
			created: 'Created',
			starting: 'Starting',
			available: 'Available',
			waiting: 'Waiting',
			completed: 'Completed',
			removed: 'Removed'
		},
		route: {
			none: 'None',
			created: 'Created',
			available: 'Available',
			disabled: 'Disabled',
			removed: 'Removed'
		},
		load: {
			none: 'None',
			created: 'Created',
			review: 'In Review',
			waiting: 'Waiting',
			processing: 'Processing',
			good: 'Good',
			incomplete: 'Incomplete',
			bad: 'Bad',
			removed: 'Removed',
			error: 'Error'			
		},
		loadSource: {
			none: 'None',
			cloud: 'Cloud',
			local: 'Local',
			service: 'Service',
			other: 'Other'
		},
		loadScope: {
			none: 'None',
			global: 'Global',
			organization: 'Organization',
			workspace: 'Workspace',
			module: 'Module'
		},
		loadFieldType: {
			none: 'None',
			int: 'Integer',
			float: 'Float',
			string: 'String'
		},
		areaType: {
			locations: 'Locations',
		},
		cycleScope: {
			complete: 'Complete',
			selected: 'Selected'
		},
		ruleFieldType: {
			none: 'None',
			min: 'Less/Equal than',
			max: 'Bigger/Equal than',
			value: 'Value',
			other: 'Other',
			composite: 'Composite'
		},
		ruleActionType: {
			none: 'None',
			filter: 'FILTER',
			exclude: 'EXCLUDE',
			include: 'INCLUDE'
		},
		ruleOperatorType: {
			none: 'None',
			and: 'AND',
			or: 'OR',
			not: 'NOT'
		},
		new: 'New',
		update: 'Update',
		changeRoute: 'Change Route',
		remove: 'Remove',
		newToRoute: 'New to Route',
		movementType: {
			new: 'New Location',
			update: 'Data update',
			append: 'Added to route',
			change: 'Route change',
			remove: 'Removed from route'
		},
		loadWeekday: {
			monday: 'Monday',
			tuesday: 'Tuesday',
			wednesday: 'Wednesday',
			thursday: 'Thursday',
			friday: 'Friday',
			saturday: 'Saturday',
			sunday: 'Sunday'
		},
		discardType: {
			rules: 'Validation failed',
			inactive: 'Inactive route',
			invalid: 'Invalid route',
			vectorized: 'Discarded by pre-filter'
		}
	}
};
